import React from 'react';
import { AlertTriangle, Info, CheckCircle2 } from 'lucide-react';
import { EduModal } from './EduModal.js';
import { EduButton } from './EduButton.js';

interface EduConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
}

export const EduConfirmDialog: React.FC<EduConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  isLoading = false,
}) => {
  const iconMap = {
    danger: <AlertTriangle className="text-status-error" size={24} />,
    warning: <AlertTriangle className="text-status-warning" size={24} />,
    info: <Info className="text-brand-primary" size={24} />,
  };

  const confirmVariantMap = {
    danger: 'destructive' as const,
    warning: 'primary' as const,
    info: 'primary' as const,
  };

  return (
    <EduModal isOpen={isOpen} onClose={isLoading ? () => {} : onClose} title={title} maxWidth="sm">
      <div className="flex items-start gap-4">
        <div className="p-2.5 rounded-full bg-surface-secondary border border-bdr shrink-0">
          {iconMap[variant]}
        </div>
        <div className="flex-1 text-sm text-txt-secondary space-y-2">
          {typeof description === 'string' ? <p>{description}</p> : description}
        </div>
      </div>

      <div className="mt-6 flex justify-end gap-2.5 pt-4 border-t border-bdr">
        <EduButton
          type="button"
          variant="secondary"
          size="sm"
          onClick={onClose}
          disabled={isLoading}
        >
          {cancelLabel}
        </EduButton>
        <EduButton
          type="button"
          variant={confirmVariantMap[variant]}
          size="sm"
          onClick={onConfirm}
          isLoading={isLoading}
        >
          {confirmLabel}
        </EduButton>
      </div>
    </EduModal>
  );
};
